// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-dirty {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
  position: absolute;
  color: var(--ids-input-dirty-indicator-color-background-dirty);
  top: 0;
}
.icon-dirty[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}
.icon-dirty.tab-dirty-tracker {
  inset-inline-start: 0;
}

.ids-color-picker .icon-dirty {
  margin-inline-start: 35px;
}

.ids-color-picker.compact .icon-dirty {
  margin-inline-start: 27px;
}

.ids-textarea .icon-dirty {
  top: 1px;
  margin-inline-start: 1px;
}
.ids-textarea .icon-dirty[dir=rtl] {
  top: 2px;
}

:host(:not([hidden])):not([color-variant=module]) {
  display: block;
}

:host(ids-tab:not([orientation=vertical]):not([color-variant=module]):first-child),
:host(ids-tab-more:not([orientation=vertical]):not([color-variant=module]):first-child),
.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*=ids-tab]:first-child {
  margin-inline-start: var(--ids-space-3xs);
}

:host(ids-tab:not([orientation=vertical]):not([color-variant=module]):last-child),
:host(ids-tab-more:not([orientation=vertical]):not([color-variant=module]):last-child),
.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*=ids-tab]:last-child {
  margin-inline-end: var(--ids-space-3xs);
}

:host(ids-tab:not([orientation=vertical]):not([color-variant=module]):not([color-variant=header]):not(:last-child)),
:host(ids-tab-more:not([orientation=vertical]):not([color-variant=module]):not(:last-child)),
.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*=ids-tab]:not(:last-child) {
  margin-inline-end: var(--ids-space-3xs);
}

:host(ids-tab:focus-visible),
:host(ids-tab-more:focus-visible),
.ids-tab-container [class*=ids-tab]:focus-visible {
  outline: none;
}

:host(ids-tab:not([has-error])) slot[name=error] {
  display: none;
}

:host(ids-tab[value=app-menu]) {
  position: sticky;
  left: 0;
  z-index: 1;
}

:host(ids-tab[editable]) .ids-tab.tab-action-container {
  margin-inline-start: auto;
}
:host(ids-tab[editable]) .ids-tab {
  min-width: var(--ids-tab-min-width);
  max-width: var(--ids-tab-max-width);
}

:host(ids-tab[editing]) .ids-tab {
  max-width: unset;
}
:host(ids-tab[editing]) .ids-tab .tab-name-editor {
  min-width: var(--ids-tab-editor-input-min-width);
  max-width: var(--ids-tab-editor-input-max-width);
  width: calc(var(--text-width, --ids-tab-editor-input-min-width));
}
:host(ids-tab[editing]) .ids-tab #ids-icon-dirty-filled {
  display: none;
}
:host(ids-tab[editing]) .ids-tab.selected {
  color: unset;
}
:host(ids-tab[editing]) .ids-tab .tab-action-container .more-options-btn {
  display: none;
}

.tab-content {
  display: none;
}

.ids-tab {
  display: flex;
  position: relative;
  align-items: center;
  color: var(--ids-tab-color-text-default);
  box-sizing: border-box;
  height: 100%;
  padding-inline: var(--ids-space-2xs);
  padding-block: var(--ids-space-xs);
  list-style: none outside none;
  user-select: none;
  cursor: pointer;
}
.ids-tab:hover:not(.more):not(.selected) {
  color: var(--ids-tab-color-text-hover);
  background-color: var(--ids-tab-color-background-hover);
}
.ids-tab:hover:not(.more):not(.selected)::after, .ids-tab:hover:not(.more):not(.selected) .selection-underline {
  background-color: var(--ids-tab-color-border-bottom);
}
.ids-tab ids-text {
  flex-grow: 1;
  padding-block: 4px;
}
.ids-tab .tab-action-container {
  display: flex;
  gap: 4px;
}
.ids-tab:hover.more, .ids-tab.is-open.more {
  background-color: var(--ids-button-tertiary-color-background-hover);
}
.ids-tab.disabled {
  cursor: default;
  color: var(--ids-tab-color-text-disabled);
  pointer-events: none;
}
.ids-tab.selected {
  color: var(--ids-tab-color-text-selected);
  cursor: default;
}
.ids-tab.selected.disabled {
  opacity: var(--ids-opacity-disabled);
}
.ids-tab.selected.ids-text {
  font-weight: 700;
}
.ids-tab.selected::after, .ids-tab.selected .selection-underline {
  background-color: var(--ids-tab-color-selected-border-bottom);
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button) {
  color: var(--ids-tab-color-text-selected);
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button) .is-focused {
  border: 1px solid transparent;
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):focus, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):focus-within, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):focus-visible, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):active, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):target {
  border: 1px solid transparent;
  box-shadow: unset;
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):hover {
  background-color: transparent;
  border: 1px solid transparent;
}
.ids-tab.selected ids-menu-button.more-options-btn::part(button) {
  color: var(--ids-tab-color-text-selected);
}
.ids-tab.selected ids-menu-button.more-options-btn:hover {
  background-color: var(--ids-button-module-color-background-hover);
  border-radius: var(--ids-button-module-border-radius);
}
.ids-tab.actionable {
  cursor: pointer;
}
.ids-tab.count {
  padding-inline: 12px;
}
.ids-tab.count .ids-tab-count-container {
  display: flex;
  flex-direction: column;
}
.ids-tab:focus-visible {
  outline: none;
}
.ids-tab .ids-tab-trigger-container {
  display: flex;
  place-content: center;
}
.ids-tab .ids-tab-trigger-container[hidden] {
  display: none;
}
.ids-tab.orientation-horizontal:not(.count) {
  padding-top: var(--ids-space-xs);
}
.ids-tab.orientation-horizontal:not(.color-variant-module) {
  border-bottom: 1px solid transparent;
  background-color: var(--ids-tab-color-background-default);
  border-radius: var(--ids-tab-border-radius-masthead);
  height: var(--ids-tab-full-height-masthead);
}
.ids-tab.orientation-horizontal:not(.color-variant-module):focus-visible {
  outline: none;
}
.ids-tab.orientation-horizontal:not(.color-variant-module):focus-visible:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 1px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-horizontal:not(.color-variant-module):focus-visible.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 0px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-horizontal:not(.color-variant-module).selected, .ids-tab.orientation-horizontal:not(.color-variant-module):hover:not(.more), .ids-tab.orientation-horizontal:not(.color-variant-module).disabled {
  border-bottom: 1px solid transparent;
}
.ids-tab.orientation-horizontal:not(.color-variant-module).selected::after, .ids-tab.orientation-horizontal:not(.color-variant-module).selected .selection-underline, .ids-tab.orientation-horizontal:not(.color-variant-module):hover:not(.more)::after, .ids-tab.orientation-horizontal:not(.color-variant-module):hover:not(.more) .selection-underline, .ids-tab.orientation-horizontal:not(.color-variant-module).disabled::after, .ids-tab.orientation-horizontal:not(.color-variant-module).disabled .selection-underline {
  position: absolute;
  height: 3px;
  inset-block-end: 0;
  inset-inline: 0;
  z-index: 1;
  pointer-events: none;
  content: "";
}
.ids-tab.orientation-horizontal ids-menu-button::part(button):hover {
  background-color: transparent;
  border: 1px solid transparent;
}
.ids-tab.has-sub-tabs {
  height: 100%;
}
.ids-tab.has-sub-tabs ids-menu-button::part(button):hover {
  background-color: unset;
}
.ids-tab ids-text::part(text),
.ids-tab .ids-tab.ids-text {
  padding-inline: 8px;
}
.ids-tab.swappable {
  padding-inline-start: var(--ids-space-xs);
  padding-inline-end: 6px;
}

.ids-tab.orientation-vertical {
  padding-inline: var(--ids-space-md);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 42px;
  background-color: var(--ids-tab-vertical-color-background-default);
  color: var(--ids-tab-vertical-color-text-default);
}
.ids-tab.orientation-vertical ids-icon {
  margin-inline-end: 8px;
}
.ids-tab.orientation-vertical ids-text[overflow=ellipsis] {
  margin-inline-end: 8px;
}
.ids-tab.orientation-vertical.count {
  padding-inline: 12px;
}
.ids-tab.orientation-vertical.count .ids-tab-count-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ids-tab.orientation-vertical ids-text::part(text),
.ids-tab.orientation-vertical .ids-tab.ids-text {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.ids-tab.orientation-vertical:hover {
  background-color: var(--ids-tab-vertical-color-background-hover);
  color: var(--ids-tab-vertical-color-text-hover);
}
.ids-tab.orientation-vertical:focus:not(:focus-visible) {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  padding-inline: calc(var(--ids-space-md) - 1px);
}
.ids-tab.orientation-vertical.disabled {
  background-color: var(--ids-tab-vertical-color-background-disabled);
  color: var(--ids-tab-vertical-color-text-disabled);
}
.ids-tab.orientation-vertical:focus-visible {
  outline: none;
}
.ids-tab.orientation-vertical:focus-visible:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 3px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-vertical:focus-visible.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 2px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-vertical.selected {
  background-color: var(--ids-tab-vertical-color-background-selected);
  color: var(--ids-tab-vertical-color-text-selected);
}
.ids-tab.orientation-vertical.selected:focus-visible:not(.hide-focus)::after, .ids-tab.orientation-vertical.selected:focus-visible:not(.hide-focus) .selection-underline {
  background-color: var(--ids-tab-vertical-color-border-selected);
}

:host(ids-tab[color-variant=module]:not(:last-child):not([value=add]):not([value=reset])) {
  background-color: var(--ids-tab-module-color-body-background);
  display: flex;
  align-items: center;
  justify-content: center;
  border-inline-end: 4px solid transparent;
}

:host(ids-tab[color-variant=module][value=add]),
:host(ids-tab[color-variant=module][value=reset]) {
  border-inline-end: 1px solid var(--ids-tab-module-color-border-right);
}

:host(ids-tab[color-variant=module][selected]) {
  align-items: flex-end;
  background: linear-gradient(to bottom, var(--ids-tab-module-color-body-background) 0%, var(--ids-tab-module-color-body-background) 85%, var(--ids-tab-module-color-background-selected) 15%, var(--ids-tab-module-color-background-selected) 100%);
}

:host(ids-tab[color-variant=module]:focus-visible) .ids-tab:not(.disabled),
:host(ids-tab[color-variant=module]:hover) .ids-tab:not(.disabled) {
  border: 0;
  background-color: var(--ids-tab-module-color-background-selected);
  outline: none;
}

:host(ids-tab[color-variant=module]:focus-visible[selected]) .ids-tab.is-focused {
  border-inline: 1px solid;
  border-block-start: 1px solid;
  border-block-end: 0;
  outline: none;
}

:host(ids-tab[color-variant=module]),
.ids-tabs-container.color-variant-module .ids-tabs-list-more {
  height: 43px;
}

.ids-tab.color-variant-module:not(.add):not(.reset):not(.more) {
  min-width: 169px;
  height: 36px;
  flex: 1;
  border-radius: 6px;
  padding-inline: 10px;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected {
  border-radius: 6px 6px 0 0;
  background-color: var(--ids-tab-module-color-background-selected);
  height: 34.5px;
  border-inline: 1px solid var(--ids-color-transparent);
  border-block-start: 1px solid var(--ids-color-transparent);
  border-block-end: 0;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected::before {
  content: " ";
  border: 0;
  position: absolute;
  right: -5px;
  bottom: -4.5px;
  width: 4px;
  height: 7px;
  border-radius: 0 0 0 6px;
  background: var(--ids-tab-module-color-body-background);
  box-shadow: 0 2px 0 0 var(--ids-tab-module-color-background-selected);
  inset-block-start: unset;
  inset-inline-start: unset;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected::after {
  content: " ";
  border: 0;
  position: absolute;
  left: -5px;
  bottom: -4.5px;
  width: 4px;
  height: 7px;
  border-radius: 0 0 6px;
  background: var(--ids-tab-module-color-body-background);
  box-shadow: 0 2px 0 0 var(--ids-tab-module-color-background-selected);
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected.is-focused:not(.hide-focus)::after {
  border-inline-end: 1px solid;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected.is-focused:not(.hide-focus)::before {
  border-inline-start: 1px solid;
}

:host(ids-tab[color-variant=module]:not([orientation=vertical]):not([actionable])),
:host(ids-tab-more[color-variant=module]:not([orientation=vertical]):not([actionable])),
.ids-tab-container.color-variant-module:not(.orientation-vertical):not(.actionable) [class*=ids-tab] {
  flex-grow: 1;
}

.ids-tab.color-variant-module {
  outline: none;
  background-color: var(--ids-tab-module-color-background-default);
  color: var(--ids-tab-module-color-text-default);
  justify-content: center;
  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);
}
.ids-tab.color-variant-module:hover:not(.more):not(.selected) {
  color: var(--ids-tab-module-color-text-hover);
  background-color: var(--ids-tab-module-color-background-hover);
}
.ids-tab.color-variant-module:hover.more {
  color: var(--ids-tab-module-color-text-hover);
  background-color: var(--ids-tab-module-color-background-hover);
}
.ids-tab.color-variant-module.selected {
  background-color: var(--ids-tab-module-color-background-selected);
  color: var(--ids-tab-module-color-text-selected);
}
.ids-tab.color-variant-module:not(.selected):focus-visible {
  outline: none;
}
.ids-tab.color-variant-module:not(.selected):focus-visible:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 3px);
  content: "";
  pointer-events: none;
}
.ids-tab.color-variant-module:not(.selected):focus-visible.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 2px);
  content: "";
  pointer-events: none;
}
.ids-tab.color-variant-module.disabled {
  background-color: var(--ids-tab-module-color-background-disabled);
  color: var(--ids-tab-module-color-text-disabled);
}
.ids-tab.color-variant-module > ids-text,
.ids-tab.color-variant-module > .ids-text {
  padding-bottom: 3px;
  text-align: center;
}
.ids-tab.color-variant-module:not(.actionable) {
  min-width: var(--ids-tab-min-width);
}
.ids-tab.color-variant-module.more {
  min-width: var(--ids-tab-more-button-width);
  height: calc(var(--ids-tab-module-height) + 1px);
}
.ids-tab.color-variant-module.actionable {
  min-width: 41px;
  gap: 0;
  height: calc(var(--ids-tab-module-height));
  margin-inline: 1px;
}
.ids-tab.color-variant-module.dismissible {
  justify-content: space-around;
}
.ids-tab.color-variant-module.dismissible > ids-text,
.ids-tab.color-variant-module.dismissible > .ids-text {
  flex-grow: 1;
}
.ids-tab.color-variant-module.dismissible.selected:not(.disabled) ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible.selected:not(.disabled) > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible.selected:not(.disabled) > ids-trigger-button, .ids-tab.color-variant-module.dismissible.is-focused:not(.disabled) ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible.is-focused:not(.disabled) > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible.is-focused:not(.disabled) > ids-trigger-button {
  color: var(--ids-tab-module-dimissible-color);
  visibility: visible;
}
.ids-tab.color-variant-module.dismissible ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible > ids-trigger-button {
  flex-grow: 0;
  flex-shrink: 1;
  visibility: hidden;
}
.ids-tab.color-variant-module.dismissible:hover ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible:hover > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible:hover > ids-trigger-button {
  visibility: visible;
}

.ids-tab.color-variant-alternate {
  color: var(--ids-tab-alternate-color-text-default);
}
.ids-tab.color-variant-alternate:hover {
  color: var(--ids-tab-alternate-color-text-hover);
}
.ids-tab.color-variant-alternate:hover::after {
  background-color: var(--ids-tab-alternate-color-background-hover);
}
.ids-tab.color-variant-alternate.selected {
  color: var(--ids-tab-alternate-color-text-selected);
}
.ids-tab.color-variant-alternate.selected::after, .ids-tab.color-variant-alternate.selected .selection-underline {
  background-color: var(--ids-tab-alternate-horizontal-color-background);
}
.ids-tab.color-variant-alternate.disabled {
  color: var(--ids-tab-alternate-color-text-disabled);
}
.ids-tab.color-variant-alternate.disabled.selected {
  color: var(--ids-tab-alternate-color-text-disabled);
}
.ids-tab.color-variant-alternate.disabled.selected::after, .ids-tab.color-variant-alternate.disabled.selected .selection-underline {
  background-color: var(--ids-tab-alternate-color-text-disabled);
}
.ids-tab.color-variant-alternate:not(.hide-focus):focus-visible, .ids-tab.color-variant-alternate:not(.hide-focus):focus, .ids-tab.color-variant-alternate:not(.hide-focus):focus-within {
  border-color: var(--ids-tab-alternate-color-border-focus);
}

.ids-tab.color-variant-header {
  color: var(--ids-tab-header-color-text-default);
}
.ids-tab.color-variant-header:hover {
  background-color: var(--ids-tab-header-color-background-hover);
  color: var(--ids-tab-header-color-text-hover);
}
.ids-tab.color-variant-header.selected {
  color: var(--ids-tab-header-color-text-selected);
}
.ids-tab.color-variant-header.selected::after, .ids-tab.color-variant-header.selected .selection-underline {
  background-color: var(--ids-tab-header-color-text-selected);
}
.ids-tab.color-variant-header.disabled {
  color: var(--ids-tab-header-color-text-disabled);
}
.ids-tab.color-variant-header:not(.hide-focus):focus-visible, .ids-tab.color-variant-header:not(.hide-focus):focus, .ids-tab.color-variant-header:not(.hide-focus):focus-within {
  border-color: var(--ids-tab-header-color-border-focus);
}
.ids-tab.color-variant-header.actionable {
  border-bottom: 0;
  padding-inline: 7px;
  padding-block-start: 7px;
  width: var(--ids-tab-header-button-width);
}
.ids-tab.color-variant-header.actionable:first-child {
  border-inline-start: 1px solid var(--ids-tab-divider-color-border);
}
.ids-tab.color-variant-header.actionable:hover {
  border-bottom: none;
  background-color: var(--ids-tab-header-color-background-hover);
  color: var(--ids-tab-header-color-text-hover);
}
.ids-tab.color-variant-header.actionable:hover::after {
  background-color: var(--ids-tab-header-color-background-hover);
}
.ids-tab.color-variant-header.actionable.add {
  border-inline-start: 1px solid var(--ids-tab-divider-color-border);
}
.ids-tab.color-variant-header.more.orientation-horizontal:not(.color-variant-module) {
  --ids-tab-divider-width: var(--ids-tab-header-button-width);
  border-inline-start: none;
}
.ids-tab.color-variant-header.more.orientation-horizontal:not(.color-variant-module) .tab-more-text > *:not(.last-child) {
  padding-inline-end: 2px;
}

.tab-more-text {
  display: inline-flex;
  align-items: center;
  padding-inline-end: 3px;
}
.tab-more-text > *:not(.last-child) {
  padding-inline-end: 3px;
  padding-block-start: 2px;
}
.tab-more-text ids-text,
.tab-more-text .ids-text {
  display: inline-block;
}

ids-popup-menu,
.ids-popup-menu {
  position: absolute;
  width: 100%;
}

.ids-tab:not(.more) ::slotted(ids-icon) {
  color: currentColor;
  pointer-events: none;
}

.ids-tab.is-focused,
.ids-tab .is-focused {
  outline: none;
}
.ids-tab.is-focused:not(.hide-focus):not(.more)::before,
.ids-tab .is-focused:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 1px);
  content: "";
  pointer-events: none;
}
.ids-tab.is-focused.color-variant-module::before,
.ids-tab .is-focused.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 0px);
  content: "";
  pointer-events: none;
}

.ids-tab.more.orientation-horizontal:not(.color-variant-module) {
  border-inline-start: 1px solid var(--ids-tab-divider-color-border);
  border-bottom: 0 solid transparent;
  margin-inline-end: 2px;
  height: var(--ids-tab-divider-width);
  width: var(--ids-tab-divider-width);
}
.ids-tab.more.orientation-horizontal:not(.color-variant-module).is-focused {
  background-color: var(--ids-button-menu-background-color-active);
}
.ids-tab.more.orientation-horizontal:not(.color-variant-module)::after {
  content: "";
  position: absolute;
  height: 44px;
  width: 44px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 2;
}

::slotted(ids-trigger-button) {
  align-items: center;
  color: currentColor;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-inline-start: 4px;
  margin-inline-end: var(--ids-tab-dismiss-button-offset);
  place-self: center;
}

::slotted(ids-trigger-button.ids-tab-close-button) {
  margin-inline-start: unset;
}

::slotted(.ids-tab-more-menu-item-text) {
  display: inline-block;
  margin-inline-start: var(--ids-space-2xs);
}`, "",{"version":3,"sources":["webpack://./src/themes/mixins/ids-dirty-tracker-mixin.scss","webpack://./src/components/ids-tabs/ids-tab.scss"],"names":[],"mappings":"AACA;EACE,0CAAA;EACA,yCAAA;EAEA,kBAAA;EACA,8DAAA;EACA,MAAA;ACDF;ADGE;EACE,wBAAA;EACA,MAAA;ACDJ;ADIE;EACE,qBAAA;ACFJ;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,QAAA;EACA,wBAAA;ACJF;ADME;EACE,QAAA;ACJJ;;AA2BA;EACE,cAAA;AAxBF;;AA8BA;;;EAGE,yCAAA;AA3BF;;AA8BA;;;EAGE,uCAAA;AA3BF;;AA8BA;;;EAGE,uCAAA;AA3BF;;AA8BA;;;EAGE,aAAA;AA3BF;;AA8BA;EACE,aAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,OAAA;EACA,UAAA;AA3BF;;AA+BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,mCAAA;EACA,mCAAA;AA7BJ;;AAkCE;EACE,gBAAA;AA/BJ;AAiCI;EACE,gDAAA;EACA,gDAAA;EACA,gEAAA;AA/BN;AAkCI;EACE,aAAA;AAhCN;AAmCI;EACE,YAAA;AAjCN;AAqCM;EACE,aAAA;AAnCR;;AA0CA;EACE,aAAA;AAvCF;;AA0CA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,sBAAA;EACA,YAAA;EACA,oCAAA;EACA,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AAvCF;AA0CE;EACE,sCAAA;EACA,uDAAA;AAxCJ;AA0CI;EAEE,oDAAA;AAzCN;AA6CE;EACE,YAAA;EACA,kBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,QAAA;AA5CJ;AA+CE;EAEE,mEAAA;AA9CJ;AAkDE;EACE,eAAA;EACA,yCAAA;EACA,oBAAA;AAhDJ;AAoDE;EACE,yCAAA;EACA,eAAA;AAlDJ;AAoDI;EACE,oCAAA;AAlDN;AAqDI;EACE,gBAAA;AAnDN;AAsDI;EAEE,6DAAA;AArDN;AAyDM;EACE,yCAAA;AAvDR;AAyDQ;EACE,6BAAA;AAvDV;AA0DQ;EAKE,6BAAA;EACA,iBAAA;AA5DV;AA+DQ;EACE,6BAAA;EACA,6BAAA;AA7DV;AAmEM;EACE,yCAAA;AAjER;AAoEM;EACE,iEAAA;EACA,qDAAA;AAlER;AAwEE;EACE,eAAA;AAtEJ;AA0EE;EACE,oBAAA;AAxEJ;AA0EI;EACE,aAAA;EACA,sBAAA;AAxEN;AA4EE;EACE,aAAA;AA1EJ;AA8EE;EACE,aAAA;EACA,qBAAA;AA5EJ;AA8EI;EACE,aAAA;AA5EN;AAkFI;EACE,gCAAA;AAhFN;AAoFI;EACE,oCAAA;EACA,yDAAA;EACA,oDAAA;EACA,2CAAA;AAlFN;AAoFM;EAlRJ,aAAA;AAiMF;AA9LI;EACE,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAgMN;AA3LI;EACE,0DAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AA6LN;AAgEM;EAnPJ,oCAAA;AAsLF;AApLE;EAEE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AAqLJ;AA4DM;EACE,6BAAA;EACA,6BAAA;AA1DR;AA+DE;EACE,YAAA;AA7DJ;AAgEM;EACE,uBAAA;AA9DR;AAmEE;;EAEE,mBAAA;AAjEJ;AAsEE;EACE,yCAAA;EACA,uBAAA;AApEJ;;AA4EA;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,YA1UwB;EA2UxB,kEAAA;EACA,iDAAA;AAzEF;AA2EE;EACE,sBAAA;AAzEJ;AA4EE;EACE,sBAAA;AA1EJ;AA8EE;EACE,oBAAA;AA5EJ;AA8EI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA5EN;AAgFE;;EAEE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AA9EJ;AAkFE;EACE,gEAAA;EACA,+CAAA;AAhFJ;AAmFE;EACE,0DAAA;EACA,+CAAA;AAjFJ;AAqFE;EACE,mEAAA;EACA,kDAAA;AAnFJ;AAsFE;EAvXA,aAAA;AAoSF;AAjSI;EACE,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAmSN;AA9RI;EACE,0DAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAgSN;AAmEE;EACE,mEAAA;EACA,kDAAA;AAjEJ;AAoEM;EAEE,+DAAA;AAnER;;AA4EA;EACE,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AAzEF;;AA4EA;;EAEE,qEAAA;AAzEF;;AA4EA;EACE,qBAAA;EACA,kPAAA;AAzEF;;AAoFE;;EACE,SAAA;EACA,iEAAA;EACA,aAAA;AAhFJ;;AAqFE;EACE,wBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;AAlFJ;;AAsFA;;EAEE,YAAA;AAnFF;;AAsFA;EACE,gBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,oBAAA;AAnFF;AAqFE;EACE,0BAAA;EACA,iEAAA;EACA,cAAA;EACA,qDAAA;EACA,0DAAA;EACA,mBAAA;AAnFJ;AAqFI;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,uDAAA;EACA,qEAAA;EACA,wBAAA;EACA,yBAAA;AAnFN;AAsFI;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,uDAAA;EACA,qEAAA;AApFN;AAyFI;EACE,4BAAA;AAvFN;AA0FI;EACE,8BAAA;AAxFN;;AA6FA;;;EAGE,YAAA;AA1FF;;AA6FA;EACE,aAAA;EACA,gEAAA;EACA,+CAAA;EACA,uBAAA;EACA,sEAAA;AA1FF;AA6FE;EACE,6CAAA;EACA,8DAAA;AA3FJ;AA8FE;EACE,6CAAA;EACA,8DAAA;AA5FJ;AAgGE;EACE,iEAAA;EACA,gDAAA;AA9FJ;AAkGE;EAjhBA,aAAA;AAkbF;AA/aI;EACE,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAibN;AA5aI;EACE,0DAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AA8aN;AA+EE;EACE,iEAAA;EACA,gDAAA;AA7EJ;AAiFE;;EAEE,mBAAA;EACA,kBAAA;AA/EJ;AAkFE;EACE,mCAAA;AAhFJ;AAmFE;EACE,2CAAA;EACA,gDAAA;AAjFJ;AAoFE;EACE,eAhjB2B;EAijB3B,MAAA;EACA,0CAAA;EACA,kBAAA;AAlFJ;AAqFE;EACE,6BAAA;AAnFJ;AAqFI;;EAEE,YAAA;AAnFN;AAwFM;;;;;EAGE,6CAAA;EACA,mBAAA;AApFR;AAwFI;;;EAGE,YAAA;EACA,cAAA;EACA,kBAAA;AAtFN;AA0FM;;;EAGE,mBAAA;AAxFR;;AAiGA;EACE,kDAAA;AA9FF;AAkGE;EACE,gDAAA;AAhGJ;AAkGI;EACE,iEAAA;AAhGN;AAqGE;EACE,mDAAA;AAnGJ;AAqGI;EAEE,sEAAA;AApGN;AAyGE;EACE,mDAAA;AAvGJ;AAyGI;EACE,mDAAA;AAvGN;AAyGM;EAEE,8DAAA;AAxGR;AA8GE;EAGE,yDAAA;AA9GJ;;AAsHA;EACE,+CAAA;AAnHF;AAqHE;EACE,8DAAA;EACA,6CAAA;AAnHJ;AAsHE;EACE,gDAAA;AApHJ;AAsHI;EAEE,2DAAA;AArHN;AAyHE;EACE,gDAAA;AAvHJ;AA4HI;EAGE,sDAAA;AA5HN;AAgIE;EACE,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yCAAA;AA9HJ;AAgII;EACE,kEAAA;AA9HN;AAiII;EACE,mBAAA;EACA,8DAAA;EACA,6CAAA;AA/HN;AAiIM;EACE,8DAAA;AA/HR;AAoIE;EACE,kEAAA;AAlIJ;AAqIE;EACE,2DAAA;EAEA,yBAAA;AApIJ;AAsII;EACE,uBAAA;AApIN;;AA2IA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AAxIF;AA0IE;EACE,uBAAA;EACA,wBAAA;AAxIJ;AA2IE;;EAEE,qBAAA;AAzIJ;;AA8IA;;EAEE,kBAAA;EACA,WAAA;AA3IF;;AAgJE;EACE,mBAAA;EACA,oBAAA;AA7IJ;;AAiJA;;EA7uBE,aAAA;AAimBF;AA9lBI;;EACE,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAimBN;AA5lBI;;EACE,0DAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AA+lBN;;AA0HA;EACE,kEAAA;EACA,kCAAA;EACA,sBAAA;EACA,oCAAA;EACA,mCAAA;AAvHF;AAyHE;EACE,gEAAA;AAvHJ;AA0HE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,UAAA;AAxHJ;;AA4HA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,uDAAA;EACA,kBAAA;AAzHF;;AA4HA;EACE,0BAAA;AAzHF;;AA4HA;EACE,qBAAA;EACA,yCAAA;AAzHF","sourcesContent":["// General Dirty-Tracker icon placement\n.icon-dirty {\n  --ids-icon-height-default: 12px !important;\n  --ids-icon-width-default: 12px !important;\n\n  position: absolute;\n  color: var(--ids-input-dirty-indicator-color-background-dirty);\n  top: 0;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n\n  &.tab-dirty-tracker {\n    inset-inline-start: 0;\n  }\n}\n\n// Color picker\n.ids-color-picker .icon-dirty {\n  margin-inline-start: 35px;\n}\n\n.ids-color-picker.compact .icon-dirty {\n  margin-inline-start: 27px;\n}\n\n.ids-textarea .icon-dirty {\n  top: 1px;\n  margin-inline-start: 1px;\n\n  &[dir='rtl'] {\n    top: 2px;\n  }\n}\n","@use '../../themes/mixins/ids-dirty-tracker-mixin' as *;\n\n$ids-tab-alternate-color-disabled: rgb(255 255 255 / 0.4);\n$ids-tab-actionable-min-width: 41px;\n$ids-tab-vertical-height: 42px;\n\n@mixin ids-tabs-focus-border($inset-x-distance: 4, $inset-y-distance: 4, $offset-x-distance: -1, $offset-y-distance: 0) {\n  outline: none;\n\n  &:not(.hide-focus):not(.more) {\n    &::before {\n      border: 1px solid var(--ids-color-action-default);\n      position: absolute;\n      inset-block-start: #{$offset-x-distance}px;\n      inset-inline-start: #{$offset-y-distance}px;\n      width: calc(100% - #{$inset-x-distance - 1}px);\n      height: calc(100% - #{$inset-y-distance - 1}px);\n      content: '';\n      pointer-events: none;\n    }\n  }\n\n  &.color-variant-module {\n    &::before {\n      border: 1px solid var(--ids-tab-module-color-focus-border);\n      border-radius: 6px;\n      position: absolute;\n      inset-block-start: #{$offset-x-distance}px;\n      inset-inline-start: #{$offset-y-distance}px;\n      width: calc(100% - #{$inset-x-distance - 1}px);\n      height: calc(100% - #{$inset-y-distance - 2}px);\n      content: '';\n      pointer-events: none;\n    }\n  }\n}\n\n// Adds the \"underline\" element for selected state.\n// cannot read css var for color in ::after\n// without shadowDOM scope so need .selection-underline div\n// as workaround\n@mixin ids-tabs-selected-underline() {\n  border-bottom: 1px solid transparent;\n\n  &::after,\n  & .selection-underline {\n    position: absolute;\n    height: 3px;\n    inset-block-end: 0;\n    inset-inline: 0;\n    z-index: 1;\n    pointer-events: none;\n    content: '';\n  }\n}\n\n:host(:not([hidden])):not([color-variant='module']) {\n  display: block;\n}\n\n// =================================================\n// Default Variant\n// =================================================\n:host(ids-tab:not([orientation='vertical']):not([color-variant='module']):first-child),\n:host(ids-tab-more:not([orientation='vertical']):not([color-variant='module']):first-child),\n.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*='ids-tab']:first-child {\n  margin-inline-start: var(--ids-space-3xs);\n}\n\n:host(ids-tab:not([orientation='vertical']):not([color-variant='module']):last-child),\n:host(ids-tab-more:not([orientation='vertical']):not([color-variant='module']):last-child),\n.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*='ids-tab']:last-child {\n  margin-inline-end: var(--ids-space-3xs);\n}\n\n:host(ids-tab:not([orientation='vertical']):not([color-variant='module']):not([color-variant='header']):not(:last-child)),\n:host(ids-tab-more:not([orientation='vertical']):not([color-variant='module']):not(:last-child)),\n.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*='ids-tab']:not(:last-child) {\n  margin-inline-end: var(--ids-space-3xs);\n}\n\n:host(ids-tab:focus-visible),\n:host(ids-tab-more:focus-visible),\n.ids-tab-container [class*='ids-tab']:focus-visible {\n  outline: none;\n}\n\n:host(ids-tab:not([has-error])) slot[name='error'] {\n  display: none;\n}\n\n:host(ids-tab[value='app-menu']) {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n}\n\n:host(ids-tab[editable]) {\n  .ids-tab.tab-action-container {\n    margin-inline-start: auto;\n  }\n\n  .ids-tab {\n    min-width: var(--ids-tab-min-width);\n    max-width: var(--ids-tab-max-width);\n  }\n}\n\n:host(ids-tab[editing]) {\n  .ids-tab {\n    max-width: unset;\n\n    .tab-name-editor {\n      min-width: var(--ids-tab-editor-input-min-width);\n      max-width: var(--ids-tab-editor-input-max-width);\n      width: calc(var(--text-width, --ids-tab-editor-input-min-width));\n    }\n\n    #ids-icon-dirty-filled {\n      display: none;\n    }\n\n    &.selected {\n      color: unset;\n    }\n\n    .tab-action-container {\n      .more-options-btn {\n        display: none;\n      }\n    }\n  }\n}\n\n\n.tab-content {\n  display: none;\n}\n\n.ids-tab {\n  display: flex;\n  position: relative;\n  align-items: center;\n  color: var(--ids-tab-color-text-default);\n  box-sizing: border-box;\n  height: 100%;\n  padding-inline: var(--ids-space-2xs);\n  padding-block: var(--ids-space-xs);\n  list-style: none outside none;\n  user-select: none;\n  cursor: pointer;\n\n  // Hover state\n  &:hover:not(.more):not(.selected) {\n    color: var(--ids-tab-color-text-hover);\n    background-color: var(--ids-tab-color-background-hover);\n\n    &::after,\n    & .selection-underline {\n      background-color: var(--ids-tab-color-border-bottom);\n    }\n  }\n\n  ids-text {\n    flex-grow: 1;\n    padding-block: 4px;\n  }\n\n  .tab-action-container {\n    display: flex;\n    gap: 4px;\n  }\n\n  &:hover.more,\n  &.is-open.more {\n    background-color: var(--ids-button-tertiary-color-background-hover);\n  }\n\n  // Disabled\n  &.disabled {\n    cursor: default;\n    color: var(--ids-tab-color-text-disabled);\n    pointer-events: none;\n  }\n\n  // Selected state\n  &.selected {\n    color: var(--ids-tab-color-text-selected);\n    cursor: default;\n\n    &.disabled {\n      opacity: var(--ids-opacity-disabled);\n    }\n\n    &.ids-text {\n      font-weight: 700;\n    }\n\n    &::after,\n    & .selection-underline {\n      background-color: var(--ids-tab-color-selected-border-bottom);\n    }\n\n    ids-menu-button:not(.more-options-btn) {\n      &::part(button) {\n        color: var(--ids-tab-color-text-selected);\n\n        .is-focused {\n          border: 1px solid transparent;\n        }\n\n        &:focus,\n        &:focus-within,\n        &:focus-visible,\n        &:active,\n        &:target {\n          border: 1px solid transparent;\n          box-shadow: unset;\n        }\n\n        &:hover {\n          background-color: transparent;\n          border: 1px solid transparent;\n        }\n      }\n    }\n\n    ids-menu-button.more-options-btn {\n      &::part(button) {\n        color: var(--ids-tab-color-text-selected);\n      }\n\n      &:hover {\n        background-color: var(--ids-button-module-color-background-hover);\n        border-radius: var(--ids-button-module-border-radius);\n      }\n    }\n  }\n\n  // Actionable\n  &.actionable {\n    cursor: pointer;\n  }\n\n  // Counts\n  &.count {\n    padding-inline: 12px;\n\n    .ids-tab-count-container {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  &:focus-visible {\n    outline: none;\n  }\n\n  // Trigger Button Slot\n  .ids-tab-trigger-container {\n    display: flex;\n    place-content: center;\n\n    &[hidden] {\n      display: none;\n    }\n  }\n\n  // Orientation-horizontal\n  &.orientation-horizontal {\n    &:not(.count) {\n      padding-top: var(--ids-space-xs);\n    }\n\n    // In-page and Header Tabs only\n    &:not(.color-variant-module) {\n      border-bottom: 1px solid transparent;\n      background-color: var(--ids-tab-color-background-default);\n      border-radius: var(--ids-tab-border-radius-masthead);\n      height: var(--ids-tab-full-height-masthead);\n\n      &:focus-visible {\n        @include ids-tabs-focus-border(0, 2, 0, -1);\n      }\n\n      &.selected,\n      &:hover:not(.more),\n      &.disabled {\n        @include ids-tabs-selected-underline;\n      }\n    }\n\n    ids-menu-button {\n      &::part(button):hover {\n        background-color: transparent;\n        border: 1px solid transparent;\n      }\n    }\n  }\n\n  &.has-sub-tabs {\n    height: 100%;\n\n    ids-menu-button {\n      &::part(button):hover {\n        background-color: unset;\n      }\n    }\n  }\n\n  ids-text::part(text),\n  .ids-tab.ids-text {\n    padding-inline: 8px;\n  }\n\n  // =================================================\n  // Tabs combined with IdsSwappable create \"swappable\" tabs\n  &.swappable {\n    padding-inline-start: var(--ids-space-xs);\n    padding-inline-end: 6px;\n  }\n}\n\n\n// =================================================\n// Vertical Variant\n// =================================================\n.ids-tab.orientation-vertical {\n  padding-inline: var(--ids-space-md);\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n  width: 100%;\n  height: $ids-tab-vertical-height;\n  background-color: var(--ids-tab-vertical-color-background-default);\n  color: var(--ids-tab-vertical-color-text-default);\n\n  ids-icon {\n    margin-inline-end: 8px;\n  }\n\n  ids-text[overflow=\"ellipsis\"] {\n    margin-inline-end: 8px;\n  }\n\n  // Counts - vertical tabs\n  &.count {\n    padding-inline: 12px;\n\n    .ids-tab-count-container {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n    }\n  }\n\n  ids-text::part(text),\n  .ids-tab.ids-text {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  // vertical hover state\n  &:hover {\n    background-color: var(--ids-tab-vertical-color-background-hover);\n    color: var(--ids-tab-vertical-color-text-hover);\n  }\n\n  &:focus:not(:focus-visible) {\n    border: 1px solid var(--ids-tab-module-color-focus-border);\n    padding-inline: calc(var(--ids-space-md) - 1px);\n  }\n\n  // vertical disabled state\n  &.disabled {\n    background-color: var(--ids-tab-vertical-color-background-disabled);\n    color: var(--ids-tab-vertical-color-text-disabled);\n  }\n\n  &:focus-visible {\n    @include ids-tabs-focus-border(4, 4, 1, 1);\n  }\n\n  // vertical selected state\n  &.selected {\n    background-color: var(--ids-tab-vertical-color-background-selected);\n    color: var(--ids-tab-vertical-color-text-selected);\n\n    &:focus-visible:not(.hide-focus) {\n      &::after,\n      & .selection-underline {\n        background-color: var(--ids-tab-vertical-color-border-selected);\n      }\n    }\n  }\n}\n\n// =================================================\n// Module Color Variant\n// =================================================\n:host(ids-tab[color-variant='module']:not(:last-child):not([value='add']):not([value='reset'])) {\n  background-color: var(--ids-tab-module-color-body-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-inline-end: 4px solid transparent;\n}\n\n:host(ids-tab[color-variant='module'][value='add']),\n:host(ids-tab[color-variant='module'][value='reset']) {\n  border-inline-end: 1px solid var(--ids-tab-module-color-border-right);\n}\n\n:host(ids-tab[color-variant='module'][selected]) {\n  align-items: flex-end;\n  background: linear-gradient(\n    to bottom,\n    var(--ids-tab-module-color-body-background) 0%,\n    var(--ids-tab-module-color-body-background) 85%,\n    var(--ids-tab-module-color-background-selected) 15%,\n    var(--ids-tab-module-color-background-selected) 100%\n  );\n}\n\n:host(ids-tab[color-variant='module']:focus-visible),\n:host(ids-tab[color-variant='module']:hover) {\n  .ids-tab:not(.disabled) {\n    border: 0;\n    background-color: var(--ids-tab-module-color-background-selected);\n    outline: none;\n  }\n}\n\n:host(ids-tab[color-variant='module']:focus-visible[selected]) {\n  .ids-tab.is-focused {\n    border-inline: 1px solid;\n    border-block-start: 1px solid;\n    border-block-end: 0;\n    outline: none;\n  }\n}\n\n:host(ids-tab[color-variant='module']),\n.ids-tabs-container.color-variant-module .ids-tabs-list-more {\n  height: 43px;\n}\n\n.ids-tab.color-variant-module:not(.add):not(.reset):not(.more) {\n  min-width: 169px;\n  height: 36px;\n  flex: 1;\n  border-radius: 6px;\n  padding-inline: 10px;\n\n  &.selected {\n    border-radius: 6px 6px 0 0;\n    background-color: var(--ids-tab-module-color-background-selected);\n    height: 34.5px;\n    border-inline: 1px solid var(--ids-color-transparent);\n    border-block-start: 1px solid var(--ids-color-transparent);\n    border-block-end: 0;\n\n    &::before {\n      content: \" \";\n      border: 0;\n      position: absolute;\n      right: -5px;\n      bottom: -4.5px;\n      width: 4px;\n      height: 7px;\n      border-radius: 0 0 0 6px;\n      background: var(--ids-tab-module-color-body-background);\n      box-shadow: 0 2px 0 0 var(--ids-tab-module-color-background-selected);\n      inset-block-start: unset;\n      inset-inline-start: unset;\n    }\n\n    &::after {\n      content: ' ';\n      border: 0;\n      position: absolute;\n      left: -5px;\n      bottom: -4.5px;\n      width: 4px;\n      height: 7px;\n      border-radius: 0 0 6px;\n      background: var(--ids-tab-module-color-body-background);\n      box-shadow: 0 2px 0 0 var(--ids-tab-module-color-background-selected);\n    }\n  }\n\n  &.selected.is-focused:not(.hide-focus) {\n    &::after {\n      border-inline-end: 1px solid;\n    }\n\n    &::before {\n      border-inline-start: 1px solid;\n    }\n  }\n}\n\n:host(ids-tab[color-variant='module']:not([orientation='vertical']):not([actionable])),\n:host(ids-tab-more[color-variant='module']:not([orientation='vertical']):not([actionable])),\n.ids-tab-container.color-variant-module:not(.orientation-vertical):not(.actionable) [class*='ids-tab'] {\n  flex-grow: 1;\n}\n\n.ids-tab.color-variant-module {\n  outline: none;\n  background-color: var(--ids-tab-module-color-background-default);\n  color: var(--ids-tab-module-color-text-default);\n  justify-content: center;\n  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);\n\n  // Module - Hover state\n  &:hover:not(.more):not(.selected) {\n    color: var(--ids-tab-module-color-text-hover);\n    background-color: var(--ids-tab-module-color-background-hover);\n  }\n\n  &:hover.more {\n    color: var(--ids-tab-module-color-text-hover);\n    background-color: var(--ids-tab-module-color-background-hover);\n  }\n\n  // Module - Selected state\n  &.selected {\n    background-color: var(--ids-tab-module-color-background-selected);\n    color: var(--ids-tab-module-color-text-selected);\n  }\n\n  // Module - Focus state\n  &:not(.selected):focus-visible {\n    @include ids-tabs-focus-border(4, 4, 1, 1);\n  }\n\n  // Module - Disabled state\n  &.disabled {\n    background-color: var(--ids-tab-module-color-background-disabled);\n    color: var(--ids-tab-module-color-text-disabled);\n  }\n\n  // Scoped to the first child text element to avoid conflicts with menus\n  > ids-text,\n  > .ids-text {\n    padding-bottom: 3px;\n    text-align: center;\n  }\n\n  &:not(.actionable) {\n    min-width: var(--ids-tab-min-width);\n  }\n\n  &.more {\n    min-width: var(--ids-tab-more-button-width);\n    height: calc(var(--ids-tab-module-height) + 1px);\n  }\n\n  &.actionable {\n    min-width: $ids-tab-actionable-min-width;\n    gap: 0;\n    height: calc(var(--ids-tab-module-height));\n    margin-inline: 1px;\n  }\n\n  &.dismissible {\n    justify-content: space-around;\n\n    > ids-text,\n    > .ids-text {\n      flex-grow: 1;\n    }\n\n    &.selected:not(.disabled),\n    &.is-focused:not(.disabled) {\n      ::slotted(ids-trigger-button),\n      > .ids-trigger-button,\n      > ids-trigger-button {\n        color: var(--ids-tab-module-dimissible-color);\n        visibility: visible;\n      }\n    }\n\n    ::slotted(ids-trigger-button),\n    > .ids-trigger-button,\n    > ids-trigger-button {\n      flex-grow: 0;\n      flex-shrink: 1;\n      visibility: hidden;\n    }\n\n    &:hover {\n      ::slotted(ids-trigger-button),\n      > .ids-trigger-button,\n      > ids-trigger-button {\n        visibility: visible;\n      }\n    }\n  }\n}\n\n// =================================================\n// Alternate Color Variant\n// =================================================\n.ids-tab.color-variant-alternate {\n  color: var(--ids-tab-alternate-color-text-default);\n\n\n  // Alternate - Hover state\n  &:hover {\n    color: var(--ids-tab-alternate-color-text-hover);\n\n    &::after {\n      background-color: var(--ids-tab-alternate-color-background-hover);\n    }\n  }\n\n  // Alternate - Selected state\n  &.selected {\n    color: var(--ids-tab-alternate-color-text-selected);\n\n    &::after,\n    & .selection-underline {\n      background-color: var(--ids-tab-alternate-horizontal-color-background);\n    }\n  }\n\n  // Alterante - Disabled state\n  &.disabled {\n    color: var(--ids-tab-alternate-color-text-disabled);\n\n    &.selected {\n      color: var(--ids-tab-alternate-color-text-disabled);\n\n      &::after,\n      & .selection-underline {\n        background-color: var(--ids-tab-alternate-color-text-disabled);\n      }\n    }\n  }\n\n  // Alternate - Focus state\n  &:not(.hide-focus):focus-visible,\n  &:not(.hide-focus):focus,\n  &:not(.hide-focus):focus-within {\n    border-color: var(--ids-tab-alternate-color-border-focus);\n  }\n}\n\n\n// =================================================\n// Header Color Variant\n// =================================================\n.ids-tab.color-variant-header {\n  color: var(--ids-tab-header-color-text-default);\n\n  &:hover {\n    background-color: var(--ids-tab-header-color-background-hover);\n    color: var(--ids-tab-header-color-text-hover);\n  }\n\n  &.selected {\n    color: var(--ids-tab-header-color-text-selected);\n\n    &::after,\n    & .selection-underline {\n      background-color: var(--ids-tab-header-color-text-selected);\n    }\n  }\n\n  &.disabled {\n    color: var(--ids-tab-header-color-text-disabled);\n  }\n\n  // Alternate - Focus state\n  &:not(.hide-focus) {\n    &:focus-visible,\n    &:focus,\n    &:focus-within {\n      border-color: var(--ids-tab-header-color-border-focus);\n    }\n  }\n\n  &.actionable {\n    border-bottom: 0;\n    padding-inline: 7px;\n    padding-block-start: 7px;\n    width: var(--ids-tab-header-button-width);\n\n    &:first-child {\n      border-inline-start: 1px solid var(--ids-tab-divider-color-border);\n    }\n\n    &:hover {\n      border-bottom: none;\n      background-color: var(--ids-tab-header-color-background-hover);\n      color: var(--ids-tab-header-color-text-hover);\n\n      &::after {\n        background-color: var(--ids-tab-header-color-background-hover);\n      }\n    }\n  }\n\n  &.actionable.add {\n    border-inline-start: 1px solid var(--ids-tab-divider-color-border);\n  }\n\n  &.more.orientation-horizontal:not(.color-variant-module) {\n    --ids-tab-divider-width: var(--ids-tab-header-button-width);\n\n    border-inline-start: none;\n\n    .tab-more-text > *:not(.last-child) {\n      padding-inline-end: 2px;\n    }\n  }\n}\n\n\n// \"More\" Tab's text content and icons are centered\n.tab-more-text {\n  display: inline-flex;\n  align-items: center;\n  padding-inline-end: 3px;\n\n  > *:not(.last-child) {\n    padding-inline-end: 3px;\n    padding-block-start: 2px;\n  }\n\n  ids-text,\n  .ids-text {\n    display: inline-block;\n  }\n}\n\n// Popupmenus inside of the \"More Tabs\" tab, or Dropdown tabs\nids-popup-menu,\n.ids-popup-menu {\n  position: absolute;\n  width: 100%;\n}\n\n// \"More Tabs\" tab flex rules\n.ids-tab:not(.more) {\n  ::slotted(ids-icon) {\n    color: currentColor;\n    pointer-events: none;\n  }\n}\n\n.ids-tab.is-focused,\n.ids-tab .is-focused {\n  @include ids-tabs-focus-border(0, 2, 0, -1);\n}\n\n.ids-tab.more.orientation-horizontal:not(.color-variant-module) {\n  border-inline-start: 1px solid var(--ids-tab-divider-color-border);\n  border-bottom: 0 solid transparent;\n  margin-inline-end: 2px;\n  height: var(--ids-tab-divider-width);\n  width: var(--ids-tab-divider-width);\n\n  &.is-focused {\n    background-color: var(--ids-button-menu-background-color-active);\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    height: 44px;\n    width: 44px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    cursor: pointer;\n    z-index: 2;\n  }\n}\n\n::slotted(ids-trigger-button) {\n  align-items: center;\n  color: currentColor;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  margin-inline-start: 4px;\n  margin-inline-end: var(--ids-tab-dismiss-button-offset);\n  place-self: center;\n}\n\n::slotted(ids-trigger-button.ids-tab-close-button) {\n  margin-inline-start: unset;\n}\n\n::slotted(.ids-tab-more-menu-item-text) {\n  display: inline-block;\n  margin-inline-start: var(--ids-space-2xs);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
